import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, tap} from 'rxjs';
import {ApiService} from './api.service';
import {UserRole} from 'app/modal/user-role';
import {Roles} from 'app/modal/roles';

@Injectable({providedIn: 'root'})
export class UserRoleService {

    private _loggedInUserRole: BehaviorSubject<Roles[] | null> = new BehaviorSubject(null);
    private _userRolesByUser: BehaviorSubject<Roles[] | null> = new BehaviorSubject(null);
    private _userRole: BehaviorSubject<UserRole | null> = new BehaviorSubject(null);
    private _userRoles: BehaviorSubject<UserRole[] | null> = new BehaviorSubject(null);


    constructor(private _apiService: ApiService) {
    }


    get userRoles$(): Observable<UserRole[]> {
        return this._userRoles.asObservable();
    }

    get loggedInUserRoles$(): Observable<Roles[]> {
        return this._loggedInUserRole.asObservable();
    }

    get userRolesByUser$(): Observable<Roles[]> {
        return this._userRolesByUser.asObservable();
    }

    get userRole$(): Observable<UserRole> {
        return this._userRole.asObservable();
    }

    getLoggedInUserRoles() {
        return this._apiService.sendGETRequest('/v1/UserRoles/getLoggedInUserRoles').pipe(
            tap((response: Roles[]) => {
                this._loggedInUserRole.next(response);
            }),
        );
    }

    getUserRolesByUser(userid: any) {
        return this._apiService.sendGETRequest('/v1/UserRoles/getRolesByUserId?userId=' + userid).pipe(
            tap((response: Roles[]) => {
                this._userRolesByUser.next(response);
            }),
        );
    }


    getUserRole(): Observable<UserRole[]> {
        this._userRole.next(null);
        return this._apiService.sendGETRequest('/v1/UserRoles/findAll').pipe(
            tap((response: UserRole[]) => {
                this._userRoles.next(response);

            }),
        );
    }

    getUserRoleById(id: string) {
        return this._apiService.sendGETRequest('/v1/UserRoles/findById?id=' + id).pipe(
            tap((response: any) => {
                this._userRole.next(response);
            }),
        );
    }

    updateRolesByUserId(id: number, userRoles: Roles[]) {
        return this._apiService.sendPOSTRequest('/v1/UserRoles/updateRolesByUserId?userId=' + id, userRoles);
    }
}
